var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreference(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.00012207V15.0001H15.5V9.37512H6.125V0.00012207H0.5ZM1.75 1.25012H4.875V2.50012H3V3.75012H4.875V5.00012H3V6.25012H4.875V7.50012H3V8.75012H4.875V9.74622L1.75 12.8712V1.25012ZM5.75391 10.6251H6.75V12.5001H8V10.6251H9.25V12.5001H10.5V10.6251H11.75V12.5001H13V10.6251H14.25V13.7501H2.62891L5.75391 10.6251Z",
    fill: "#02DE7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreference);
export default __webpack_public_path__ + "static/media/preference.a851e32242b3660ba34925f2a60d88d5.svg";
export { ForwardRef as ReactComponent };